import './_news-carousel.scss';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function NewsCarousel() {
    const newsCarousel = document.querySelectorAll('.news-carousel');

    if (newsCarousel.length > 0) {
        newsCarousel.forEach((item, index) => {
            const carouselNews = item.querySelector('.carousel-news') as HTMLElement;
            const swiperContainer = carouselNews.querySelector('.views-element-container') as HTMLElement;
            const swiperWrapper = swiperContainer.querySelector('.cactus_view_rows') as HTMLElement;
            swiperWrapper.classList.add('swiper-wrapper');
            swiperContainer.setAttribute('id', `swiper-news-${index}`);
            const slides = swiperContainer.querySelectorAll('.swiper-slide');
            const swiperBtnNext = carouselNews.querySelector('.swiper-button-next') as HTMLElement;
            const swiperBtnPrev = carouselNews.querySelector('.swiper-button-prev') as HTMLElement;
            const swiperPagination = carouselNews.querySelector('.swiper-pagination') as HTMLElement;

            const swiper = new Swiper(swiperContainer, {
                modules: [Navigation, Pagination],
                pagination: {
                    el: swiperPagination,
                    clickable: true,
                },
                navigation: {
                    nextEl: swiperBtnNext,
                    prevEl: swiperBtnPrev,
                    addIcons: false,
                },
                breakpoints: {
                    0: {
                        loop: slides.length > 1,
                        spaceBetween: 0,
                        slidesPerView: 1.3,
                        slidesPerGroup: 1,
                    },
                    768: {
                        loop: slides.length > 2,
                        spaceBetween: 28,
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                    },
                },
                on: {
                    afterInit: function () {
                        const bullets = swiperPagination.querySelectorAll('.swiper-pagination-bullet');
                        bullets.forEach((bullet: any) => {
                            bullet.setAttribute('tabindex', '0');
                            bullet.addEventListener('keydown', (event: any) => {
                                if (event.key === 'ArrowLeft') {
                                    event.preventDefault();
                                    swiper.slidePrev();
                                } else if (event.key === 'ArrowRight') {
                                    event.preventDefault();
                                    swiper.slideNext();
                                }
                            });
                        });
                    },
                    //al caricamento della pagina, il focus viene impostato sul primo bullet e questo causa un effetto di scroll della pagina, quindi ho commentato questa parte di codice
                    // slideChange: function () {
                    //     if (swiperPagination) {
                    //const currentSlide = swiperPagination.querySelector('.swiper-pagination-bullet.swiper-pagination-bullet-active') as HTMLDivElement;
                    // if (currentSlide) {
                    //     currentSlide.focus();
                    // }
                    //  }
                    //},
                },
            });

            if (swiperBtnNext) {
                swiperBtnNext.addEventListener('keypress', function (e) {
                    if (e.code === 'Enter') {
                        swiper.slideNext();
                    }
                });
            }

            if (swiperBtnPrev) {
                swiperBtnPrev.addEventListener('keypress', function (e) {
                    if (e.code === 'Enter') {
                        swiper.slidePrev();
                    }
                });
            }

            swiper.init();
        });
    }
}
